<template>

    <v-card class="elevation-12" id="login">
        <v-toolbar dark color="warning">
            <v-btn text icon @click="back"><v-icon>keyboard_arrow_left</v-icon></v-btn>
            <v-toolbar-title>{{trans('auth-pages.email.title')}}</v-toolbar-title>

        </v-toolbar>
        <template v-if="!sent">
            <v-card-text>

                <v-alert
                        v-if="error"
                        type="error"
                        >{{error}}</v-alert>
                <v-form ref="form"
                        @submit.prevent
                        v-model="validForm"
                    >
                    <v-text-field
                            v-if="emailLogin"
                            prepend-icon="email"
                            name="email"
                            type="email"
                            :label="trans('auth-pages.email.labels.email')"
                            :rules="emailRules"
                            :required="true"

                            :error-messages="fieldErrors.email"
                            @input="resetError('email')"
                            v-model="email"
                        ></v-text-field>
                    <p class="lead">{{trans('auth-pages.email.lead')}}</p>


                </v-form>
            </v-card-text>
            <v-card-actions>

            <v-spacer></v-spacer>
            <v-btn
                    :disabled="!validForm"
                    color="primary"
                    @click="submit"
            ><v-icon left>send</v-icon>{{trans('auth-pages.email.submit')}}</v-btn>

            <v-spacer></v-spacer>
        </v-card-actions>
        </template>
        <template v-else>
            <v-card-text>
                <v-row align="center" justify="center">
                    <v-icon d-flex size="80pt" mx-auto>move_to_inbox</v-icon>
                </v-row>
                <div class="text-h5 text-center">{{trans('auth-pages.email.on-success')}}</div>
                <!--Successfull email password recovery-->


            </v-card-text>
        </template>
    </v-card>
</template>
<script>
    export default {
        name: "password-recover",
        props: {
            emailLogin:{type:Boolean,default:true,},
            action:{type:String,default:'/password/email'},
        },
        data() {
            return {
                email:'',
                emailRules:[v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v)||'invalid email'],

                validForm:false,

                sent:false,

                error:null,
                fieldErrors:{},
            }
        },
        mounted() {
        },
        computed: {},
        methods: {
            back(){
                this.$emit('back')
            },
            submit(){

                let data ={
                    email:this.email
                };

                axios.post(this.action,data)
                    .then(r=>{
                        this.$emit('sent');
                        this.sent=true;
                    })
                    .catch(e=>{
                        if(e.response){
                            if(e.response.data){
                                console.log({e});
                                if(e.response.status===422){
                                    this.fieldErrors = e.response.data.errors;
                                }

                                this.error = e.response.data.message;
                            }
                            else{
                                this.error=e.response;
                            }
                        }else{
                            this.error=e;
                        }
                    })
            },
            resetError(field){
                this.fieldErrors[field]=[];
                this.error=null
            }
        },

        components: {},
        filters: {}
    }
</script>
